import 'css-chunksrc/client/scenes/projectElementsSecondaryCriteria/styles.scss';export default {
  "secondaryCriteria": "_secondaryCriteria_1awph_1",
  "row": "_row_1awph_8",
  "label": "_label_1awph_13",
  "form": "_form_1awph_24"
};